import React, { useState, useEffect } from 'react'

import Head from '../head'

const email = 'chankwanlok35@hotmail.com'
const instagram = 'kwanlok.ink'

const ContactForm = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  return (
    <form
      name="contact"
      method="POST"
      netlify-honeypot="bot-field"
      data-netlify="true"
    >
      <input type="hidden" name="form-name" value="contact" />
      <p className="bot-field">
        <label>
          Don’t fill this out if you’re human: <input name="bot-field" />
        </label>
      </p>
      <p>
        <input
          type="text"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          size="40"
          aria-required="true"
          aria-invalid="false"
          placeholder="Your name"
          required
        />
      </p>
      <p>
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          size="40"
          aria-required="true"
          aria-invalid="false"
          placeholder="Your email"
          required
        />
      </p>
      <p>
        <textarea
          name="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          cols="40"
          rows="10"
          aria-invalid="false"
          placeholder="Message"
        ></textarea>
      </p>
      <p>
        <button type="submit">{'Send'}</button>
      </p>
      <div data-netlify-recaptcha="true" />
    </form>
  )
}

const ContactPage = () => {
  const desc = `Contact me through email: ${email} and follow me on instergram: ${instagram}`

  return (
    <div className="row contact-page">
      <Head title="Contact" desc={desc} />
      <div className="column">
        <h1>GET IN TOUCH:</h1>
        <p>{`Email: ${email}`}</p>
        <p className="ins">{`Instagram: ${instagram}`}</p>
        <a
          href="https://www.instagram.com/kwanlok.ink/"
          target="_blank"
          rel="noreferrer"
        >
          <div className="ins-icon">
            <i className="gg-icon-ins" />
          </div>
        </a>
      </div>
      <div className="column">
        <h1>CONTACT:</h1>
        <ContactForm />
      </div>
    </div>
  )
}

export default ContactPage
